/* Favre — film 360° po najechaniu na zdjęcie kafla (katalog / kolekcje, snippets/favre-card.liquid).
   Kafel z filmem ma .fg__media[data-v360]. Tylko myszka (hover: hover); jeden <video> na kafel,
   tworzony przy pierwszym najechaniu, pokazywany dopiero gdy gra (bez czarnej klatki), znaczek „360°”. */
(() => {
  if (window.__favre360) return;
  window.__favre360 = true;
  const hover = matchMedia('(hover: hover)');
  const film = (media) => {
    let v = media.querySelector('.fl__v360');
    if (v) return v;
    v = document.createElement('video');
    v.className = 'fl__v360';
    v.muted = true;
    v.loop = true;
    v.playsInline = true;
    v.preload = 'auto';
    v.setAttribute('aria-hidden', 'true');
    v.src = media.dataset.v360;
    v.addEventListener('playing', () => { if (media.matches(':hover')) media.classList.add('is-360'); });
    media.appendChild(v);
    const znak = document.createElement('span');
    znak.className = 'fl__360';
    znak.setAttribute('aria-hidden', 'true');
    znak.textContent = '360°';
    media.appendChild(znak);
    return v;
  };
  document.addEventListener('mouseover', (e) => {
    if (!hover.matches) return;
    const media = e.target.closest?.('.fg__media[data-v360]');
    if (!media || media.contains(e.relatedTarget)) return;
    const v = film(media);
    v.currentTime = 0;
    v.play().catch(() => {});
  });
  document.addEventListener('mouseout', (e) => {
    const media = e.target.closest?.('.fg__media[data-v360]');
    if (!media || media.contains(e.relatedTarget)) return;
    media.classList.remove('is-360');
    media.querySelector('.fl__v360')?.pause();
  });
})();
